"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var SelectsInFilter_1 = __importDefault(require("./SelectsInFilter"));
var useStyles = core_1.makeStyles(function (theme) { return ({
    root: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        position: 'relative',
    },
    selectButton: {
        width: '100%',
    },
}); });
var FilterSelector = function (props) {
    var selectedText = props.selectedText, isDisplaySelects = props.isDisplaySelects, toggleDisplaySelectsFn = props.toggleDisplaySelectsFn;
    var classes = useStyles();
    return (react_1.default.createElement(core_1.Box, { className: classes.root },
        react_1.default.createElement(core_1.Button, { className: classes.selectButton, variant: 'outlined', onClick: toggleDisplaySelectsFn },
            selectedText,
            react_1.default.createElement(core_1.Typography, { variant: 'body1' }, ' ▾ ')),
        isDisplaySelects && (react_1.default.createElement(SelectsInFilter_1.default, __assign({}, props, { closeSelectsFn: toggleDisplaySelectsFn })))));
};
exports.default = FilterSelector;
